import { memo, useMemo } from 'react';
import type { CustomBrandDivision, Brand } from '@apiTypes';
import { VStack } from '@library';
import BrandsListDivisionBrands from './BrandsListDivisionBrands';

const BrandsListDivisions = ({
    divisions,
    brands,
    onBrandSelect,
}: {
    divisions: CustomBrandDivision[];
    brands: Brand[];
    onBrandSelect?: () => void;
}) => {
    const filteredDivisions = useMemo(
        () =>
            divisions.filter(division => {
                // Hide division if there is no brands associated with it
                if (division.brands.length === 0) return false;

                // hide divisions that don't have any brands after filters are applied
                return brands.find(brand => {
                    return division.brands.includes(
                        brand.slug.toLocaleLowerCase()
                    );
                });
            }),
        [brands, divisions]
    );

    return (
        <VStack gap="huge">
            {filteredDivisions.map(division => (
                <BrandsListDivisionBrands
                    key={division.id}
                    division={division}
                    brands={brands}
                    onBrandSelect={onBrandSelect}
                />
            ))}
        </VStack>
    );
};

export default memo(BrandsListDivisions);
